import { useEffect, useRef } from "react";
import { useMap } from "@vis.gl/react-google-maps";

export const ExistingPolylines = ({
  zones,
  editingZone,
  onPolygonEdit,
  zoomToZone,
  isEditing,
  parentBoundaries,
}) => {
  const map = useMap();
  const polygonsRef = useRef({});
  const editingPolygonRef = useRef(null);
  useEffect(() => {
    if (!map) return;

    Object.values(polygonsRef.current).forEach((polygon) => {
      polygon.setMap(null);
    });
    if (editingPolygonRef.current) {
      editingPolygonRef.current.setMap(null);
    }

    polygonsRef.current = {};
    editingPolygonRef.current = null;

    const parentPolygon = new window.google.maps.Polygon({
      paths: parentBoundaries,
      map,
      fillColor: "#f0f0f0",
      fillOpacity: 0.2,
      strokeColor: "#6d18ff",
      strokeWeight: 2,
      editable: false,
      draggable: false,
      clickable: false,
    });

    zones.forEach((zone) => {
      if (zone.id !== editingZone?.id) {
        const polyline = new window.google.maps.Polyline({
          path: zone.coordinates,
          map,
          strokeColor: "#096dd9",
          strokeWeight: 2,
          editable: false,
          draggable: false,
          clickable: false,
        });
        polygonsRef.current[zone.id] = polyline;
      }
    });

    if (editingZone) {
      const editingPolyline = new window.google.maps.Polyline({
        path: editingZone.coordinates,
        map,
        strokeColor: "#f5222d",
        strokeWeight: 2,
        editable: isEditing,
        draggable: isEditing,
        clickable: isEditing,
      });

      editingPolygonRef.current = editingPolyline;

      const updateCoordinates = () => {
        const path = editingPolyline.getPath();
        const newCoordinates = Array(path.getLength())
          .fill(null)
          .map((_, i) => ({
            lat: path.getAt(i).lat(),
            lng: path.getAt(i).lng(),
          }));
        onPolygonEdit(newCoordinates);
      };

      editingPolyline.addListener("dragend", updateCoordinates);

      const path = editingPolyline.getPath();
      window.google.maps.event.addListener(
        path,
        "insert_at",
        updateCoordinates
      );
      window.google.maps.event.addListener(
        path,
        "remove_at",
        updateCoordinates
      );
      window.google.maps.event.addListener(path, "set_at", updateCoordinates);
    }

    if (zoomToZone) {
      const bounds = new window.google.maps.LatLngBounds();
      zoomToZone.coordinates.forEach((coord) => {
        bounds.extend(new window.google.maps.LatLng(coord.lat, coord.lng));
      });
      map.fitBounds(bounds);

      const padding = { top: 50, right: 50, bottom: 50, left: 50 };
      map.fitBounds(bounds, padding);
    }

    return () => {
      Object.values(polygonsRef.current).forEach((polygon) => {
        polygon.setMap(null);
        window.google.maps.event.clearInstanceListeners(polygon);
      });
      if (editingPolygonRef.current) {
        editingPolygonRef.current.setMap(null);
        window.google.maps.event.clearInstanceListeners(
          editingPolygonRef.current
        );
        if (editingPolygonRef.current.getPath()) {
          window.google.maps.event.clearInstanceListeners(
            editingPolygonRef.current.getPath()
          );
        }
      }
      parentPolygon.setMap(null);
    };
  }, [
    map,
    zones,
    editingZone,
    onPolygonEdit,
    zoomToZone,
    isEditing,
    parentBoundaries,
  ]);

  return null;
};
